import React, { useState } from "react";
import { Table, Button, Modal, ModalFooter, ModalBody, ModalHeader, Nav, TabContent, TabPane, UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";
import { AddNewButton, Page, LoadingMsg, PendingButton } from "components/common";
import { Trans } from "react-i18next";
import { ApiClient, PayrollClient } from "services";
import { NotificationManager } from "react-notifications";
import { useTable } from "hooks";
import { employeeNotes as importantNotes } from '../../UserList/modelNames';
import ImportModal from "components/ImportModal";
import { createPortal } from "react-dom";
import { useHistory } from "react-router-dom";
import { ColouredLink } from "components/HoverCard";
import { TableValues } from "pages/Core/CoreComponents";
import EmployeeDetailsDocument from "components/documents/EmployeeDetails"
import withDocumentRenderer from "components/DocumentRenderer/withDocumentRenderer";
import { exportDownload, humanError } from "services/util";
import StatusBox from "components/StatusBox";


const EmployeeDetails = ({ employee, setActiveTab, activeTab }) => {
  if (!employee) {
    return null;
  }

  return (
    <div className="inv-tabs nw-list mt-2">
      <Nav tabs className="nw-tabs2 inv-tabs mb-3">
        <div style={{ cursor: 'pointer' }} onClick={() => setActiveTab('1')} className={activeTab == '1' ? `active-tab` : ``}>
          <Trans>General Information</Trans>
        </div>
        <div style={{ cursor: 'pointer' }} onClick={() => setActiveTab('2')} className={activeTab == '2' ? `active-tab` : ``}>
          <Trans>Job Information</Trans>
        </div>
        <div style={{ cursor: 'pointer' }} onClick={() => setActiveTab('3')} className={activeTab == '3' ? `active-tab` : ``}>
          <Trans>Bank Information</Trans>
        </div>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <table className="table table-bordered">
            <tbody>
              <TableValues label="Status" value={employee.status} />
              <TableValues label="Serial Number" value={employee.serial_number} />
              <TableValues label="Full Name" value={employee.full_name} />
              <TableValues label="Email" value={employee.email} />
              <TableValues label="Phone Number" value={employee.phone_number} />
              <TableValues label="Date of Birth" value={employee.date_of_birth} />
              <TableValues label="Joining Date" value={employee.start_date} />
              <TableValues label="Position" value={employee.position} />
              <TableValues label="Nationality" value={employee.nationality} />
              <TableValues label="Qualification" value={employee.qualification} />
              <TableValues label="ID Number" value={employee.id_number} />
              <TableValues label="ID End Date" value={employee.id_end_date} />
            </tbody>
          </table>
        </TabPane>
      </TabContent>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="2">
          <table className="table table-bordered">
            <tbody>
              <TableValues label="Monthly Salary" value={employee.monthly_salary} />
              <TableValues label="Shift Appointed" value={employee.shift_adj?.name} />
              <TableValues label="End Date" value={employee.end_date} />
              <TableValues label="Holiday Balance" value={employee.holiday_balance} />
              <TableValues label="Holiday Offset" value={employee.holiday_offset} />
              <TableValues label="Number of Holiday Days" value={employee.num_holiday_days} />
            </tbody>
          </table>
        </TabPane>
      </TabContent>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="3">
          <table className="table table-bordered">
            <tbody>

              <TableValues label="Bank Name" value={employee.bank_name} />
              <TableValues label="Account Number" value={employee.account_number} />
              <TableValues label="IBAN" value={employee.iban} />
              <TableValues label="Swift" value={employee.swift} />
              <TableValues label="Route" value={employee.route} />
            </tbody>
          </table>
          <table className="table table-bordered">
            <tbody>
              <TableValues label="Insurance Start Date" value={employee.start_date_insurance} />
              <TableValues label="Insurance Number" value={employee.medical_number} />
              <TableValues label="Insurance Category" value={employee.category} />
              <TableValues label="Insurance Company" value={employee.company_name} />
              <TableValues label="Insurance End Date" value={employee.end_date_insurance} />
            </tbody>
          </table>
        </TabPane>
      </TabContent>
    </div>
  );
};


const DownloadDetails = withDocumentRenderer({
  footer: false,
  onDownload:
    ({ item }) =>
      (getDocument) => {
        getDocument(
          {
            item,
          },
          `${item.first_name}_${item.serial_number}.pdf`
        );
      },
})(({ DownloadDocument, DocumentRenderer, item, t, selectedOrganisation }) => {
  return (
    <>
      <DownloadDocument className="mx-1" compact={false} label={t("Download PDF")} selectedOrganisation={selectedOrganisation} />
      <DocumentRenderer component={EmployeeDetailsDocument} item={item} />
    </>
  )
});

const PrintCell = withDocumentRenderer({
  footer: false,
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `${item.first_name}_${item.serial_number}.pdf`
    ),
})(({ PrintDocument, DocumentRenderer, item, t, selectedOrganisation }) => (
  <>
    <PrintDocument className="mx-1" item={item} label={t("Print Employee Details")} selectedOrganisation={selectedOrganisation} />
    <DocumentRenderer component={EmployeeDetailsDocument} />
  </>
));


const EmailDetails = withDocumentRenderer({
  footer: false,
  onDownload:
    ({ item }) =>
      (getDocument) => {
        getDocument(
          {
            item,
          },
          `${item.first_name}_${item.serial_number}.pdf`
        );
      },
})(({ EmailDocument, DocumentRenderer, item, t, selectedOrganisation }) => {
  return (
    <>
      <EmailDocument className="mx-1" item={item} compact={false} label={t("Send Details")} />
      <DocumentRenderer component={EmployeeDetailsDocument} item={item} selectedOrganisation={selectedOrganisation} />
    </>
  )
});

export const EmployeeList = ({ match, url = "/employees", t, selectedOrganisation }) => {
  const [showInactiveEmployee, setShowInactiveEmployee] = useState(false);

  const {
    TableContainer,
    data,
    PayrollTableDataFetch,
    EditDeleteButtons,
    onDeleteItem,
    ViewingRecords,
    Pagination,
    PayrollBulkDeleteButton,
    TableSearch,
    refreshData,
    BulkDelet,
    filters,
    setFilters,
  } = useTable({
    url,
    match,
    filters: {
      status: showInactiveEmployee ? 'Inactive' : 'Active',
    },
    limit: 20
  });

  const history = useHistory()

  const apiClient = ApiClient();
  const payroll = PayrollClient()
  const [activeTab, setActiveTab] = useState('1');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isDetailsOpen, setisOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false)

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeDetails = () => {
    setisOpen(false);
  };

  const closeConfirm = () => {
    setIsConfirmOpen(false);
  };


  const handleUploadFile = async (selectedFile) => {

    const formData = new FormData();
    setIsLoading(true)
    formData.append('file', selectedFile)
    formData.append('id', selectedOrganisation.id)

    apiClient.post("import_bulk_employee", formData)
      .then(({ data }) => {
        if (data.status) {
          setIsLoading(false)
          NotificationManager.success(t("File imported successfully"));
          setTimeout(() => {
            setIsModalOpen(false);
            refreshData()
          }, 800);
        } else {
          NotificationManager.error(t('Error while importing File ' + data.message));
          setIsLoading(false)
          refreshData()
        }
      })
      .catch((err) => {
        setIsLoading(false)
        if (err.response?.data?.type === 'missing') {
          NotificationManager.error(t('Data is missing from column') + ' ' + err.response?.data?.column + ' ' + t('for') + ' ' + err.response?.data?.employee);
        } else {
          
          NotificationManager.error(humanError(err, "Error while importing File", t));
        }
        refreshData()
      }).finally(() => setIsLoading(false))
  }

  const [employeeDetails, setDetails] = useState()
  const [isConfirming, setConfirming] = useState()

  const onUserClick = async (details, fullModal) => {

    setDetails(details)

    if (fullModal) {
      setisOpen(true)
    } else {
      setIsConfirmOpen(true)
    }
  }

  const isActive = employeeDetails?.status === "Active"

  const changedStatus = isActive ? "Inactive" : "Active"

  const handleConfirm = async () => {

    if (!employeeDetails) {
      NotificationManager.error(t("No ID Found"))
      return
    }

    setConfirming(true)

    const postData = {
      status: changedStatus
    }

    payroll.patch(`employees/${employeeDetails.id}/update_status`, postData)
      .then(({ data }) => {
        NotificationManager.success(t(`User Status changed ${"to " + changedStatus || "!"}`));
        setTimeout(() => {
          setConfirming(false)
          setIsConfirmOpen(false)
          refreshData()
        }, 800);
      })
      .catch((err) => {
        setConfirming(false)
        NotificationManager.error(t('Error while importing File ' + err));
        refreshData()
      });
  }

  const handleAttachmentClick = (details) => {

    const { id, full_name } = details

    const attachURL = `/payroll/attachments?id=${id}&name=${full_name}`;
    history.push(attachURL);
    console.log(id)
  };

  const attachmentLink = () => {
    history.push(`/payroll/attachments`)
  };

  async function sendInvitation(value) {
    if (!value.email) {
      NotificationManager.error(t('Please enter a valid employee email for invitation.'))
      return
    }
    // dispatch(actions.setPending(model, true));
    try {
      await payroll.post(`employees/${value.id}/resend_invite`).get("data");
      NotificationManager.success(t("Invite email successfully sent"));
      refreshData()
    } finally {
      // dispatch(actions.setPending(model, false));
    }
  }

  const copyInviteLink = (inviteLink) => {
    try {
      navigator.clipboard.writeText(inviteLink);
      NotificationManager.success('Invite link copied to clipboard');
    } catch (error) {
      NotificationManager.error('Failed to copy invite link');
    } finally {
    }
  };

  const renderInvitationStatus = (employee) => {
    const { user, status, invitation_link } = employee;

    if (user) {
      return <span className="fa fa-check-circle text-success" />;
    }

    if (invitation_link) {
      return (
        <span className="btn btn-sm btn-outline-success copy-invite-link" onClick={() => copyInviteLink(invitation_link)} title={t(`Copy Link`)} style={{ cursor: 'pointer' }}>
          <Trans>Invitation Sent</Trans>
          <i className="fas fa-copy mx-1" />
        </span>
      );
    }

    return (
      <Button
        size="sm"
        color="primary"
        title={status !== "Active" ? "Employee must be active to send invitation" : ""}
        disabled={status !== "Active"}
        onClick={() => sendInvitation(employee)}
      >
        <i className="fas fa-paper-plane mr-2" />
        <Trans>Invite</Trans>
      </Button>
    );
  };

  const handleResolveRequest = async (requestId, action) => {
    try {
      await payroll.post(`iqama-renewal-requests/${requestId}/handle-request`, { action, manager_notes: '' })
      NotificationManager.success(t("Iqama renewal request has been resolved"));
      refreshData()
    } catch (error) {
      NotificationManager.error(error.response?.data?.error || "An error occurred");
    }
  }

  const IqamaQuickView = ({ employee }) => {
    const request = employee.iqama_renewal_request;

    return (
      <UncontrolledPopover trigger="hover" placement="right" target={`iqama-${employee.id}`}>
        <PopoverHeader>
          <Trans>Iqama Renewal Request</Trans>
        </PopoverHeader>
        <PopoverBody>
          {request ? (
            <>
              <div><strong><Trans>Iqama Number:</Trans></strong> {employee.id_number}</div>
              <div><strong><Trans>Expiry:</Trans></strong> {request.expiry_date}</div>
              <div><strong><Trans>Note:</Trans></strong> {request.employee_notes}</div>
              <div className="iqama-request-status"><strong><Trans>Request Status:</Trans></strong> <StatusBox status={request.status} /></div>
              {request.status === 'PENDING' && (
                <div className="d-flex justify-content-center">
                  <Button size="sm" color="primary" className="mt-2" onClick={() => handleResolveRequest(request.id, 'complete')}>
                    <Trans>Accept</Trans>
                  </Button>
                  <Button size="sm" color="danger" className="mt-2" onClick={() => handleResolveRequest(request.id, 'reject')}>
                    <Trans>Reject</Trans>
                  </Button>
                </div>
              )}
            </>
          ) : (
            <Trans>No active Iqama requests</Trans>
          )}
        </PopoverBody>
      </UncontrolledPopover>
    );
  };


  if (!data) return null;
  return (
    <Page title="Employees" className="inv-table">
      {isLoading &&
        createPortal(
          <div className="content">
            <div className="loader"></div>
            {<LoadingMsg />}
          </div>, document.querySelector('#loader-holder')
        )}
      <Modal isOpen={isDetailsOpen} toggle={closeDetails} size="lg">
        <ModalHeader>
          <div><Trans>Employee Details</Trans></div>
        </ModalHeader>
        <ModalBody>
          <div className="d-flex justify-space-between">
            <DownloadDetails item={employeeDetails} t={t} selectedOrganisation={selectedOrganisation} />
            <EmailDetails item={employeeDetails} t={t} selectedOrganisation={selectedOrganisation} />
            <PrintCell item={employeeDetails} t={t} selectedOrganisation={selectedOrganisation} />
          </div>
          <EmployeeDetails employee={employeeDetails} setActiveTab={setActiveTab} activeTab={activeTab} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => closeDetails()}>Close</Button>
        </ModalFooter>
      </Modal>
      <div className="search row">
        <div className="col-8">
          <TableSearch label={t("Search by Name, Serial Number, Email...")} />
        </div>
        <div className="col-3 px-0">
          <input type="submit" value={t("Search")} className="btn btn-primary" />
        </div>
      </div>
      <Modal isOpen={isConfirmOpen} toggle={closeConfirm}>
        <ModalHeader><Trans>Change User Status</Trans></ModalHeader>
        <ModalBody>
          <Trans>Are you sure you want to change this user's status to {changedStatus || "Active"}?</Trans>
        </ModalBody>
        <ModalFooter>
          <Button onClick={closeConfirm}><Trans>Close</Trans></Button>
          {isConfirming ?
            <Button className="mx-0" disabled color="primary"><span className="fa fa-spinner fa-spin" /> <Trans>Changing</Trans></Button>
            :
            <Button className="mx-0" onClick={handleConfirm} color={isActive ? "danger" : "primary"}><Trans>{isActive ? "Deactivate" : "Activate"}</Trans></Button>
          }
        </ModalFooter>
      </Modal>
      <div div className="d-flex align-items-center my-3">
        <AddNewButton resource="Employee" match={match} />
        <Button color="primary" onClick={openModal}>
          <i className="fas fa-file-excel mr-2" /><Trans>Import Employees</Trans>
        </Button>
        <Button size="md" color="primary" onClick={() => { exportDownload(payroll, `employees/export?status=${showInactiveEmployee ? 'Inactive' : 'Active'}`, 'employees.xlsx') }}>
          <Trans>Export</Trans> <span className="mx-1" /><i className="fas fa-file-excel" />
        </Button>
        <ImportModal
          isOpen={isModalOpen}
          toggle={closeModal}
          title="Employees"
          importantNotes={importantNotes}
          handleUpload={handleUploadFile}
          templateName="employees_import_template"
        />
        <div className="mx-auto" />
        <Button onClick={attachmentLink} color="primary"><i className="fas fa-paperclip mr-2" /><Trans>Attachments</Trans></Button>
      </div>
      <div className="d-flex justify-content-end mb-1 mt-2">

        <PendingButton
          color="link"
          className="p-0"
          onClick={() => {
            setFilters({ ...filters, status: showInactiveEmployee ? 'Active' : 'Inactive' });
            setShowInactiveEmployee(!showInactiveEmployee);
          }}
        >
          View {!showInactiveEmployee ? "Inactive Employees" : "Active Employees"}
        </PendingButton>
      </div>
      <BulkDelet className="d-none" />
      <TableContainer>
        <Table responsive style={{ border: '1px solid #e9ecef' }}>
          <thead>
            <tr>
              <th sortBy="serial_number" className="text-left">
                <Trans>S-No.</Trans>
              </th>
              <th sortBy="first_name" className="text-nowrap">
                <Trans>Name</Trans>
              </th>
              {/* <th sortBy="last_name" className="text-nowrap">
                <Trans>Last Name</Trans>
              </th> */}
              <th sortBy="email" className="text-nowrap">
                <Trans>Email Address</Trans>
              </th>
              <th sortBy="phone_number" className="text-nowrap">
                <Trans>Phone Number</Trans>
              </th>
              <th className="text-nowrap">
                <Trans>Status</Trans>
              </th>
              <th className="text-nowrap">
                <Trans>Attachments</Trans>
              </th>
              <th className="text-nowrap">
                <Trans>Linked</Trans>
              </th>
              <th><Trans>Actions</Trans></th>
            </tr>
          </thead>
          <tbody>
            {data.results.map((i) => {
              const userActive = i.status === "Active"
              return (
                <tr key={i.id}>
                  <td className="text-left">{i.serial_number}</td>
                  <td>
                    <ColouredLink onClick={() => onUserClick(i, true)}>{i.first_name} {i.last_name}</ColouredLink>
                    {i.iqama_renewal_request && <>
                      <Button
                        id={`iqama-${i.id}`}
                        color="link"
                        className="p-0 px-1 mx-0 link"
                      >
                        <i className="fas fa-envelope" />
                      </Button>
                      <IqamaQuickView employee={i} />
                    </>}

                  </td>
                  {/* <td>{i.last_name}</td> */}
                  <td>{i.email}</td>
                  <td>{i.phone_number}</td>
                  <td>
                    <Button className="mx-1" size="sm" outline={true} color={userActive ? "success" : "danger"} onClick={() => onUserClick(i)}>{i.status}</Button>
                  </td>
                  <td className="text-muted"><ColouredLink onClick={() => handleAttachmentClick(i)}>{i.attachments_count === 0 ? t("-") : <>{i.attachments_count}<i style={{ fontSize: "1.2em" }} className="far fa-file border ml-1" /></>}</ColouredLink></td>
                  <td>
                    {renderInvitationStatus(i)}
                  </td>
                  <td className="text-end text-nowrap">
                    <EditDeleteButtons
                      url={match.url}
                      id={i.id}
                      allowDelete={false}
                      showDelete={false}
                      // onDelete={onDeleteItem}
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </TableContainer>
      <PayrollTableDataFetch />
      <div className="d-flex justify-content-between">
        <div className=""><ViewingRecords noCount /></div>
        <div className=""><Pagination /></div>
      </div>
    </Page>
  )
};

export default EmployeeList;
